import { ErrorComponent, MainFooter, MainHeader, PageLayout } from "shared";
import { useAppScope } from "master/contexts";
import { MwcdLogoComopent, OfflineText } from "..";
import { OfflineImage } from "assets/images/OfflineImage";

export const OfflinePage = ({ onOfflineReload }) => {
    const { lanSettings } = useAppScope();

    return (
        <>
            <MainHeader />
            <PageLayout isBreadCrumbsRequired={false}>
                <div className="pb-3 mb-1">
                    <MwcdLogoComopent />
                </div>
                <div style={{ height: "100%" }}>
                    <ErrorComponent
                        title={`${OfflineText.title[lanSettings?.lan || "en"]}`}
                        message={`${OfflineText.description[lanSettings?.lan || "en"]}`}
                        image={OfflineImage}
                        btnLabel={`${OfflineText.button[lanSettings?.lan || "en"]}`}
                        onClick={onOfflineReload}
                    />
                </div>
            </PageLayout>
            <MainFooter />
        </>
    );
};
